module.exports = {"320282001":"宜城街道","320282002":"屺亭街道","320282003":"新庄街道","320282004":"新街街道","320282005":"芳桥街道","320282100":"张渚镇","320282101":"西渚镇","320282102":"太华镇","320282103":"徐舍镇","320282104":"官林镇","320282105":"杨巷镇","320282106":"新建镇","320282107":"和桥镇","320282108":"高塍镇","320282109":"万石镇","320282110":"周铁镇","320282112":"丁蜀镇","320282113":"湖父镇","320282400":"环科园","320282401":"宜兴经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320282.json
// module id = 783
// module chunks = 0